import { useCallback, useMemo, useState } from 'react';
export const useStack = () => {
    const [stack, setStack] = useState([]);
    const push = useCallback((el) => setStack([el, ...stack]), [stack]);
    const pop = useCallback(([head, ...rest]) => {
        setStack(rest);
        return head;
    }, []);
    const head = stack[0];
    const without = useCallback((el) => setStack(stack.filter((e) => e !== el)), [stack]);
    const clear = useCallback(() => setStack([]), []);
    return useMemo(() => ({ push, pop, head, without, clear }), [head, pop, push, without, clear]);
};
//# sourceMappingURL=useStack.js.map